import React from "react";

export interface IIsin {
    isin?: string;
    isAvailable: boolean;
}

export interface IIsinsComponentProps {
    isins: IIsin[];
    state?: string;
}

export const IsinTableComponent: React.FunctionComponent<IIsinsComponentProps> = (props: IIsinsComponentProps) => {
    const { isins, state } = props;

    const presentIsins = isins?.filter(i => i.isAvailable)?.map(i => i.isin);
    const missingIsins = isins?.filter(i => !i.isAvailable)?.map(i => i.isin);
    return state !== "Completed" ? (
        <div>
            <b>Entered ISINs:</b> {isins?.map(i => i.isin)?.join(", ")}
        </div>
    ) : (
        <div>
            <div>
                <b>Processed ISINs:</b> {presentIsins?.join(", ") || "No processed ISIN"}
            </div>
            {missingIsins.length > 0 && (
                <div>
                    <b>Missing ISINs:</b> {missingIsins?.join(", ")}
                </div>
            )}
        </div>
    );
};
